export default {"src":"/bnb/_next/static/media/faq_light.f4d79586.svg","height":24,"width":24};